import http from "utils/http";

const areasApi = {
  getAreas: async () => http.get<Area[]>("ob/organizations/areas-list/"),
};

export default areasApi;
